// extracted by css-extract-rspack-plugin
export default {"cls1":"ModalError-cls1_q60","cls2":"ModalError-cls2_g2k ModalError-cls1_q60"};